import { render, staticRenderFns } from "./UiMarkerPoint.vue?vue&type=template&id=cbb17124&scoped=true"
import script from "./UiMarkerPoint.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiMarkerPoint.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UiMarkerPoint.vue?vue&type=style&index=0&id=cbb17124&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb17124",
  null
  
)

export default component.exports